import './steps/stepWithBackground';
import './steps/start-experience';
import './steps/start-over';
import './steps/stars';
const superZoom = require('./super-zoom');
const animations = require('./animation.product-finder');
const videoControls = require('./video-controls');
const slidingRadioButtons = require('./steps/slidingRadioButtons');
const BREAKPOINTS = require('../../../experience/breakpoints.json');

let shouldNotSubmitForm = false;
let animateBeforeStepDuration = 500;
window.STEP_ANIMAION_DURATION = 1000;
window.isLoading = false;

// TODO: set to TRUE in dev mode
animations.animateLoader( false );

// Load next step
$(document.body).on('submit', 'form.step', async function (e) {
    e.preventDefault();

    if (shouldNotSubmitForm) {
        shouldNotSubmitForm = false;
        return;
    }

    window.isLoading = true;
    await animations.animateBeforeStep(this, animateBeforeStepDuration);

    let oppositeDirection = $(this).find('input[value="previousStep"]').length > 0;

    $.ajax({
        url: $(this).attr('action'),
        type: $(this).attr('method'),
        dataType: 'json',
        data: $(this).serialize(),
        complete: async function (data) {
            let content = $('.step-container', data.responseText);
            if (content) {
                $('.steps').append(content.html());
            }

            // If old videos are paused, pause the new ones
            if (videoControls.isVideoPaused) {
                videoControls.pauseVideos();
            }

            await animations.animateSteps(oppositeDirection);
        },
    });
});

// Disable answer click if the step is still loading
$(document).on('click', '.step__answer--next_on_click', (e) => {
    e.preventDefault();
    if (window.isLoading) { return; }

    handleNextOnClick(e);
});

// Disable answer click if the step is still loading
// And active answer on mobile to force a second click to go to the next step
$(document).on('click', '.step__answer--next_on_click_or_open_mobile', (e) => {
    e.preventDefault();
    if (window.hasSwiped || window.isLoading) { return; }

    if (window.innerWidth >= BREAKPOINTS.tablet || superZoom.isActive || $(e.currentTarget).hasClass('mobile-active')) {
        handleNextOnClick(e);
    } else {
        $(e.currentTarget).closest('.step__answers').find('.step__answer').removeClass('mobile-active');
        $(e.currentTarget).addClass('mobile-active');
    }
});

// Handle back button click that should display previous step
$(document).on('click', '.stepper_pagination__back_button', async (e) => { // eslint-disable-line no-unused-vars
    if (window.isLoading) { return; }

    // Add input previous step
    $('.step:last-child').append(`<input type="hidden" name="getPreviousStep" value="previousStep"/>`);

    await handlePreviousAction();
});

// Disable form submit on recommendation product button
$(document).on( 'click', '.step_recommendation__selection--perfect_match button, .step_recommendation__selection--best_sellers button', () => {
    shouldNotSubmitForm = true;
});

const handleNextOnClick = (e) => {
    const $clickedElement = $(e.currentTarget);

    $clickedElement.addClass('active');
    $clickedElement.closest('form').append(`<input type="hidden" name="getNextStep" value="nextStep"/>`);
    $clickedElement.closest('.step__answer').find('input[name="currentAnswer"]').prop('checked', true);

    // Trigger form submit
    $(e.currentTarget).closest('.step').find('button[value="nextStep"]').trigger('click');
};

const handlePreviousAction = async () => {
    // Get the previous button
    const lastStep = $('.step').last()[0];
    const previousStep = $(lastStep).prev()[0];

    const previousButton = $(lastStep).find('button[value="previousStep"]');
    if ($(lastStep).attr('step-number') > 1) {
        $(previousButton).trigger('click');
        $(previousStep).remove();
    } else {
        await animations.animateSteps(true);
    }
};

const productFinderResize = () => {
    // Add device class to body
    $('body')
        .toggleClass('mobile', window.innerWidth < BREAKPOINTS.mobile)
        .toggleClass('tablet', window.innerWidth >= BREAKPOINTS.mobile && window.innerWidth < BREAKPOINTS.tablet)
        .toggleClass('desktop', window.innerWidth >= BREAKPOINTS.tablet);

    // Reset swiper
    slidingRadioButtons.scrollAnimation();

    // Define the header height in css
    document.querySelector(':root').style.setProperty('--header-height', $( 'header' ).outerHeight() + 'px');
};

// Run code on page load
$(() => {
    productFinderResize();
    $('footer').removeClass('footer--recommendation').attr('aria-hidden', 'true');
});
window.addEventListener('resize', productFinderResize);
